module.exports = __webpack_public_path__ + "static/media/flag.a0ccbe18.svg";